/**
 * Image-only scheduled slideshow.
 * Filters by data-start / data-end in the browser (Liquid `now` freezes under CDN).
 * Images are Shopify CDN URLs already on the page - never fetches the app host.
 * Upcoming slides stay as data-* until live so the browser does not download them.
 * Rechecks at the next start/end (exact time) with a 30-minute backup.
 */
(function () {
  "use strict";

  var BACKUP_MS = 30 * 60 * 1000;
  var SWIPER_WAIT_MS = 50;
  var SWIPER_WAIT_MAX = 120;

  function parseEpoch(value) {
    if (value === null || value === undefined || value === "") return null;
    var n = Number(value);
    if (!Number.isFinite(n)) return null;
    if (n > 1e12) return n;
    return n * 1000;
  }

  function isLive(el, now) {
    var start = parseEpoch(el.getAttribute("data-start"));
    var end = parseEpoch(el.getAttribute("data-end"));
    if (start !== null && now < start) return false;
    if (end !== null && now >= end) return false;
    return true;
  }

  function sortSlides(slides) {
    return slides.slice().sort(function (a, b) {
      var sa = Number(a.getAttribute("data-sort") || 100);
      var sb = Number(b.getAttribute("data-sort") || 100);
      return sa - sb;
    });
  }

  function previewNow() {
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get("ss_at") || params.get("preview_at");
      if (!raw) return Date.now();
      var t = Date.parse(raw);
      return Number.isFinite(t) ? t : Date.now();
    } catch (e) {
      return Date.now();
    }
  }

  function liveKey(slides) {
    return slides
      .map(function (el) {
        return (el.getAttribute("data-desktop") || "") + ":" + (el.getAttribute("data-sort") || "");
      })
      .join("|");
  }

  function hydrateSlide(el, first) {
    if (el.querySelector("picture, img")) return;
    var desk = el.getAttribute("data-desktop") || "";
    var mob = el.getAttribute("data-mobile") || desk;
    if (!desk && !mob) return;
    var alt = el.getAttribute("data-alt") || "";
    var href = el.getAttribute("data-href") || "";

    var hero = document.createElement("div");
    hero.className = "ss-hero ss-hero--image";

    var picture = document.createElement("picture");
    if (mob && mob !== desk) {
      var source = document.createElement("source");
      source.media = "(max-width: 800px)";
      source.srcset = mob;
      picture.appendChild(source);
    }
    var img = document.createElement("img");
    img.className = "ss-hero-image-full";
    img.src = desk || mob;
    img.alt = alt;
    img.decoding = "async";
    img.draggable = false;
    img.loading = "eager";
    if (first) img.setAttribute("fetchpriority", "high");
    picture.appendChild(img);

    if (href) {
      var a = document.createElement("a");
      a.className = "ss-hero-slide-link";
      a.href = href;
      a.draggable = false;
      a.style.pointerEvents = "none";
      a.appendChild(picture);
      hero.appendChild(a);
    } else {
      hero.appendChild(picture);
    }
    el.appendChild(hero);
  }

  function disableSlideLinks(root) {
    var links = root.querySelectorAll("a.ss-hero-slide-link");
    for (var i = 0; i < links.length; i++) {
      links[i].draggable = false;
      links[i].style.pointerEvents = "none";
      links[i].setAttribute("draggable", "false");
    }
  }

  function slideHref(slide) {
    if (!slide) return "";
    var href = slide.getAttribute("data-href") || "";
    if (href) return href;
    var a = slide.querySelector("a.ss-hero-slide-link");
    return a ? a.getAttribute("href") || "" : "";
  }

  function bindDragClickGuard(viewport) {
    if (!viewport || viewport.getAttribute("data-ss-drag-guard") === "1") return;
    viewport.setAttribute("data-ss-drag-guard", "1");
    var sx = 0;
    var sy = 0;
    var dragged = false;
    var THRESH = 8;
    var skip =
      ".ss-nav, [data-ss-pagination], .swiper-pagination, .swiper-pagination-bullet, .ss-dot";

    viewport.addEventListener(
      "pointerdown",
      function (e) {
        if (e.target.closest(skip)) return;
        sx = e.clientX;
        sy = e.clientY;
        dragged = false;
      },
      true
    );
    viewport.addEventListener(
      "pointermove",
      function (e) {
        if (Math.abs(e.clientX - sx) > THRESH || Math.abs(e.clientY - sy) > THRESH) {
          dragged = true;
        }
      },
      true
    );
    viewport.addEventListener(
      "pointerup",
      function (e) {
        if (dragged) return;
        if (e.button && e.button !== 0) return;
        if (e.target.closest(skip)) return;
        var slide = e.target.closest("[data-ss-slide]");
        var href = slideHref(slide);
        if (href) window.location.assign(href);
      },
      true
    );
    viewport.addEventListener(
      "click",
      function (e) {
        if (e.target.closest("a.ss-hero-slide-link")) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );
    viewport.addEventListener(
      "dragstart",
      function (e) {
        e.preventDefault();
      },
      true
    );
  }

  function destroyCarousel(root) {
    if (root._ssSwiper && typeof root._ssSwiper.destroy === "function") {
      try {
        root._ssSwiper.destroy(true, true);
      } catch (e) {}
      root._ssSwiper = null;
    }
    if (root._ssAuto) {
      clearInterval(root._ssAuto);
      root._ssAuto = null;
    }
    var oldWrapper = root.querySelector("[data-ss-wrapper]");
    if (oldWrapper) {
      oldWrapper.style.transform = "";
      var clones = oldWrapper.querySelectorAll("[data-ss-clone], .swiper-slide-duplicate");
      for (var c = 0; c < clones.length; c++) {
        if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
      }
    }
  }

  function whenSwiper(cb) {
    if (window.Swiper) {
      cb();
      return;
    }
    var n = 0;
    var t = setInterval(function () {
      n += 1;
      if (window.Swiper) {
        clearInterval(t);
        cb();
        return;
      }
      if (n >= SWIPER_WAIT_MAX) clearInterval(t);
    }, SWIPER_WAIT_MS);
  }

  function syncArrows(root, count) {
    var multi = count >= 2;
    if (multi) root.classList.add("ss-slideshow--multi");
    else root.classList.remove("ss-slideshow--multi");
    var navs = root.querySelectorAll(".ss-nav");
    for (var i = 0; i < navs.length; i++) {
      navs[i].hidden = !multi;
    }
  }

  function bindArrowControls(root) {
    if (root.getAttribute("data-ss-arrows") === "1") return;
    root.setAttribute("data-ss-arrows", "1");
    root.addEventListener(
      "pointerup",
      function (e) {
        var prev = e.target.closest("[data-ss-prev]");
        var next = e.target.closest("[data-ss-next]");
        if (!prev && !next) return;
        e.preventDefault();
        e.stopPropagation();
        if (!root._ssSwiper) return;
        if (prev) root._ssSwiper.slidePrev();
        if (next) root._ssSwiper.slideNext();
      },
      true
    );
  }

  function mountCarousel(root) {
    var viewport = root.querySelector("[data-ss-swiper]");
    var wrapper = root.querySelector("[data-ss-wrapper]");
    var pag = root.querySelector("[data-ss-pagination]");
    if (!viewport || !wrapper) return;

    destroyCarousel(root);
    disableSlideLinks(root);
    bindDragClickGuard(viewport);
    bindArrowControls(root);

    var slides = wrapper.querySelectorAll("[data-ss-slide]");
    var count = slides.length;
    root.setAttribute("data-ss-count", String(count));
    syncArrows(root, count);
    if (pag) pag.innerHTML = "";
    if (count < 2) return;

    whenSwiper(function () {
      if (!window.Swiper || root._ssSwiper) return;
      if (!root.isConnected) return;
      if (wrapper.querySelectorAll("[data-ss-slide]").length < 2) return;

      var delay = Number(root.getAttribute("data-delay") || 6000);
      if (!delay || delay < 1000) delay = 6000;
      var autoplay = root.getAttribute("data-autoplay") !== "false";
      var prevEl = root.querySelector("[data-ss-prev]");
      var nextEl = root.querySelector("[data-ss-next]");

      viewport.classList.add("swiper");
      wrapper.classList.add("swiper-wrapper");
      var liveSlides = wrapper.querySelectorAll("[data-ss-slide]");
      for (var s = 0; s < liveSlides.length; s++) {
        liveSlides[s].classList.add("swiper-slide");
      }
      if (pag) {
        pag.classList.add("swiper-pagination");
        pag.innerHTML = "";
      }

      root._ssSwiper = new window.Swiper(viewport, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        loop: true,
        rewind: false,
        speed: 600,
        watchOverflow: false,
        allowTouchMove: true,
        simulateTouch: true,
        followFinger: true,
        grabCursor: false,
        cssMode: false,
        shortSwipes: true,
        longSwipes: true,
        longSwipesRatio: 0.15,
        threshold: 4,
        touchRatio: 1,
        resistanceRatio: 0.85,
        preventClicks: true,
        preventClicksPropagation: true,
        observer: true,
        observeParents: true,
        autoplay: autoplay
          ? {
              delay: delay,
              disableOnInteraction: false,
              reverseDirection: false,
              stopOnLastSlide: false,
            }
          : false,
        pagination: pag
          ? {
              el: pag,
              clickable: true,
              type: "bullets",
            }
          : undefined,
        navigation:
          prevEl && nextEl
            ? { prevEl: prevEl, nextEl: nextEl, disabledClass: "ss-nav-idle" }
            : undefined,
      });

      viewport.classList.remove("swiper-grab-cursor");
      viewport.style.cursor = "pointer";

      if (root._ssSwiper) {
        root._ssSwiper.on("touchMove", function () {
          if (root._ssSwiper) root._ssSwiper.allowClick = false;
        });
      }
    });
  }

  function nextCheckDelay(slides, now) {
    var next = now + BACKUP_MS;
    for (var i = 0; i < slides.length; i++) {
      var start = parseEpoch(slides[i].getAttribute("data-start"));
      var end = parseEpoch(slides[i].getAttribute("data-end"));
      if (start !== null && start > now && start < next) next = start;
      if (end !== null && end > now && end < next) next = end;
    }
    return Math.max(250, next - now + 50);
  }

  function scheduleNext(root, slides, now) {
    if (root._ssTimer) clearTimeout(root._ssTimer);
    root._ssTimer = setTimeout(function () {
      filterRoot(root);
    }, nextCheckDelay(slides, now));
  }

  function filterRoot(root) {
    var now = previewNow();
    var wrapper = root.querySelector("[data-ss-wrapper]");
    var catalog = root.querySelector("[data-ss-catalog]");
    if (!wrapper || !catalog) return;

    var all = Array.prototype.slice.call(root.querySelectorAll("[data-ss-slide]"));
    var live = sortSlides(all.filter(function (el) { return isLive(el, now); }));
    var dead = all.filter(function (el) { return live.indexOf(el) === -1; });

    var emptyEl = root.querySelector("[data-ss-empty]");
    var emptyMode = root.getAttribute("data-empty-mode") || "hide";

    scheduleNext(root, all, now);

    if (live.length === 0) {
      root.setAttribute("data-ss-count", "0");
      syncArrows(root, 0);
      if (emptyMode === "hide") {
        root.hidden = true;
        if (emptyEl) emptyEl.hidden = true;
      } else {
        root.hidden = false;
        if (emptyEl) emptyEl.hidden = false;
      }
      all.forEach(function (el) { catalog.appendChild(el); });
      if (root.getAttribute("data-ss-live-key") !== "") {
        root.setAttribute("data-ss-live-key", "");
        destroyCarousel(root);
      }
      return;
    }

    root.hidden = false;
    root.setAttribute("data-ss-count", String(live.length));
    syncArrows(root, live.length);
    if (emptyEl) emptyEl.hidden = true;

    var key = liveKey(live);
    if (root.getAttribute("data-ss-live-key") === key) return;
    root.setAttribute("data-ss-live-key", key);

    dead.forEach(function (el) { catalog.appendChild(el); });
    live.forEach(function (el, idx) {
      hydrateSlide(el, idx === 0);
      wrapper.appendChild(el);
    });

    mountCarousel(root);
  }

  function initRoot(root) {
    if (root.getAttribute("data-ss-ready") === "1") return;
    root.setAttribute("data-ss-ready", "1");
    bindArrowControls(root);
    filterRoot(root);
  }

  function initAll() {
    document.querySelectorAll("[data-ss-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function () {
    document.querySelectorAll("[data-ss-root]").forEach(function (root) {
      root.removeAttribute("data-ss-ready");
      root.removeAttribute("data-ss-live-key");
      destroyCarousel(root);
      initRoot(root);
    });
  });
})();
